import { TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import React from "react";
import { ActivityLogContext } from "../context/activityLogContext";
import { ActivityLogSortColumn } from "../interface/iActivityLogSort";

const COLUMNS: { column: ActivityLogSortColumn; label: string }[] = [
  { column: "date", label: "Zeitpunkt" },
  { column: "actor", label: "Handelnder" },
  { column: "role", label: "Rolle" },
  { column: "area", label: "Bereich" },
  { column: "action", label: "Aktion" },
  { column: "subject", label: "Betroffener" },
  { column: "status", label: "Status" },
];

const ActivityLogTableHead = (): React.JSX.Element => {
  const { sort, toggleSort } = React.useContext(ActivityLogContext);

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <span style={visuallyHidden}>Details</span>
        </TableCell>
        {COLUMNS.map(({ column, label }) => {
          const isSorted = sort.column === column;

          return (
            <TableCell
              key={column}
              aria-sort={
                isSorted
                  ? sort.direction === "asc"
                    ? "ascending"
                    : "descending"
                  : undefined
              }
              sx={{ fontWeight: 600 }}
            >
              <TableSortLabel
                active={isSorted}
                direction={isSorted ? sort.direction : "asc"}
                onClick={() => toggleSort(column)}
              >
                {label}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

export default ActivityLogTableHead;
